// Standard international countries list with country calling codes, flags, currencies and live exchange rates
export const COUNTRIES = [
  { code: 'IN', dial: '+91', name: 'India', flag: '🇮🇳', currency: 'INR', symbol: '₹', rateToINR: 1, phoneLen: 10 },
  { code: 'US', dial: '+1', name: 'United States', flag: '🇺🇸', currency: 'USD', symbol: '$', rateToINR: 95.92, phoneLen: 10 },
  { code: 'GB', dial: '+44', name: 'United Kingdom', flag: '🇬🇧', currency: 'GBP', symbol: '£', rateToINR: 129.45, phoneLen: 10 },
  { code: 'AE', dial: '+971', name: 'United Arab Emirates', flag: '🇦🇪', currency: 'AED', symbol: 'AED ', rateToINR: 26.12, phoneLen: 9 },
  { code: 'CA', dial: '+1', name: 'Canada', flag: '🇨🇦', currency: 'CAD', symbol: 'CA$', rateToINR: 69.01, phoneLen: 10 },
  { code: 'AU', dial: '+61', name: 'Australia', flag: '🇦🇺', currency: 'AUD', symbol: 'A$', rateToINR: 68.43, phoneLen: 9 },
  { code: 'SG', dial: '+65', name: 'Singapore', flag: '🇸🇬', currency: 'SGD', symbol: 'S$', rateToINR: 75.49, phoneLen: 8 },
  { code: 'SA', dial: '+966', name: 'Saudi Arabia', flag: '🇸🇦', currency: 'SAR', symbol: 'SAR ', rateToINR: 25.58, phoneLen: 9 },
  { code: 'QA', dial: '+974', name: 'Qatar', flag: '🇶🇦', currency: 'QAR', symbol: 'QAR ', rateToINR: 26.35, phoneLen: 8 },
  { code: 'KW', dial: '+965', name: 'Kuwait', flag: '🇰🇼', currency: 'KWD', symbol: 'KWD ', rateToINR: 310.96, phoneLen: 8 },
  { code: 'OM', dial: '+968', name: 'Oman', flag: '🇴🇲', currency: 'OMR', symbol: 'OMR ', rateToINR: 249.47, phoneLen: 8 },
  { code: 'BH', dial: '+973', name: 'Bahrain', flag: '🇧🇭', currency: 'BHD', symbol: 'BHD ', rateToINR: 255.11, phoneLen: 8 },
  { code: 'DE', dial: '+49', name: 'Germany', flag: '🇩🇪', currency: 'EUR', symbol: '€', rateToINR: 110.80, phoneLen: 10 },
  { code: 'FR', dial: '+33', name: 'France', flag: '🇫🇷', currency: 'EUR', symbol: '€', rateToINR: 110.80, phoneLen: 9 },
  { code: 'IT', dial: '+39', name: 'Italy', flag: '🇮🇹', currency: 'EUR', symbol: '€', rateToINR: 110.80, phoneLen: 10 },
  { code: 'ES', dial: '+34', name: 'Spain', flag: '🇪🇸', currency: 'EUR', symbol: '€', rateToINR: 110.80, phoneLen: 9 },
  { code: 'NL', dial: '+31', name: 'Netherlands', flag: '🇳🇱', currency: 'EUR', symbol: '€', rateToINR: 110.80, phoneLen: 9 },
  { code: 'SE', dial: '+46', name: 'Sweden', flag: '🇸🇪', currency: 'SEK', symbol: 'kr ', rateToINR: 9.83, phoneLen: 9 },
  { code: 'CH', dial: '+41', name: 'Switzerland', flag: '🇨🇭', currency: 'CHF', symbol: 'CHF ', rateToINR: 117.34, phoneLen: 9 },
  { code: 'ZA', dial: '+27', name: 'South Africa', flag: '🇿🇦', currency: 'ZAR', symbol: 'R ', rateToINR: 5.90, phoneLen: 9 },
  { code: 'NZ', dial: '+64', name: 'New Zealand', flag: '🇳🇿', currency: 'NZD', symbol: 'NZ$', rateToINR: 55.42, phoneLen: 9 },
  { code: 'MY', dial: '+60', name: 'Malaysia', flag: '🇲🇾', currency: 'MYR', symbol: 'RM ', rateToINR: 23.53, phoneLen: 9 },
  { code: 'ID', dial: '+62', name: 'Indonesia', flag: '🇮🇩', currency: 'IDR', symbol: 'Rp ', rateToINR: 0.00543, phoneLen: 10 },
  { code: 'TH', dial: '+66', name: 'Thailand', flag: '🇹🇭', currency: 'THB', symbol: '฿', rateToINR: 2.88, phoneLen: 9 },
  { code: 'PH', dial: '+63', name: 'Philippines', flag: '🇵🇭', currency: 'PHP', symbol: '₱', rateToINR: 1.52, phoneLen: 10 },
  { code: 'VN', dial: '+84', name: 'Vietnam', flag: '🇻🇳', currency: 'VND', symbol: '₫', rateToINR: 0.00370, phoneLen: 9 },
  { code: 'JP', dial: '+81', name: 'Japan', flag: '🇯🇵', currency: 'JPY', symbol: '¥', rateToINR: 0.621, phoneLen: 10 },
  { code: 'KR', dial: '+82', name: 'South Korea', flag: '🇰🇷', currency: 'KRW', symbol: '₩', rateToINR: 0.0712, phoneLen: 10 },
  { code: 'CN', dial: '+86', name: 'China', flag: '🇨🇳', currency: 'CNY', symbol: '¥', rateToINR: 14.26, phoneLen: 11 },
  { code: 'HK', dial: '+852', name: 'Hong Kong', flag: '🇭🇰', currency: 'HKD', symbol: 'HK$', rateToINR: 12.23, phoneLen: 8 },
  { code: 'NP', dial: '+977', name: 'Nepal', flag: '🇳🇵', currency: 'NPR', symbol: 'रू ', rateToINR: 0.626, phoneLen: 10 },
  { code: 'BD', dial: '+880', name: 'Bangladesh', flag: '🇧🇩', currency: 'BDT', symbol: '৳', rateToINR: 0.778, phoneLen: 10 },
  { code: 'LK', dial: '+94', name: 'Sri Lanka', flag: '🇱🇰', currency: 'LKR', symbol: 'Rs ', rateToINR: 0.292, phoneLen: 9 },
  { code: 'PK', dial: '+92', name: 'Pakistan', flag: '🇵🇰', currency: 'PKR', symbol: 'Rs ', rateToINR: 0.345, phoneLen: 10 },
  { code: 'BR', dial: '+55', name: 'Brazil', flag: '🇧🇷', currency: 'BRL', symbol: 'R$ ', rateToINR: 18.64, phoneLen: 11 },
  { code: 'MX', dial: '+52', name: 'Mexico', flag: '🇲🇽', currency: 'MXN', symbol: 'Mex$ ', rateToINR: 5.60, phoneLen: 10 },
  { code: 'NG', dial: '+234', name: 'Nigeria', flag: '🇳🇬', currency: 'NGN', symbol: '₦', rateToINR: 0.0723, phoneLen: 10 },
  { code: 'KE', dial: '+254', name: 'Kenya', flag: '🇰🇪', currency: 'KES', symbol: 'KSh ', rateToINR: 0.741, phoneLen: 9 },
  { code: 'EG', dial: '+20', name: 'Egypt', flag: '🇪🇬', currency: 'EGP', symbol: 'E£ ', rateToINR: 1.85, phoneLen: 10 },
  { code: 'TR', dial: '+90', name: 'Turkey', flag: '🇹🇷', currency: 'TRY', symbol: '₺', rateToINR: 1.97, phoneLen: 10 },
  { code: 'RU', dial: '+7', name: 'Russia', flag: '🇷🇺', currency: 'RUB', symbol: '₽', rateToINR: 1.137, phoneLen: 10 },
  { code: 'PL', dial: '+48', name: 'Poland', flag: '🇵🇱', currency: 'PLN', symbol: 'zł ', rateToINR: 25.52, phoneLen: 9 },
  { code: 'PT', dial: '+351', name: 'Portugal', flag: '🇵🇹', currency: 'EUR', symbol: '€', rateToINR: 110.80, phoneLen: 9 },
  { code: 'IE', dial: '+353', name: 'Ireland', flag: '🇮🇪', currency: 'EUR', symbol: '€', rateToINR: 110.80, phoneLen: 9 },
  { code: 'BE', dial: '+32', name: 'Belgium', flag: '🇧🇪', currency: 'EUR', symbol: '€', rateToINR: 110.80, phoneLen: 9 },
  { code: 'AT', dial: '+43', name: 'Austria', flag: '🇦🇹', currency: 'EUR', symbol: '€', rateToINR: 110.80, phoneLen: 10 },
  { code: 'NO', dial: '+47', name: 'Norway', flag: '🇳🇴', currency: 'NOK', symbol: 'kr ', rateToINR: 10.28, phoneLen: 8 },
  { code: 'DK', dial: '+45', name: 'Denmark', flag: '🇩🇰', currency: 'DKK', symbol: 'kr. ', rateToINR: 14.82, phoneLen: 8 },
  { code: 'FI', dial: '+358', name: 'Finland', flag: '🇫🇮', currency: 'EUR', symbol: '€', rateToINR: 110.80, phoneLen: 9 },
  { code: 'GR', dial: '+30', name: 'Greece', flag: '🇬🇷', currency: 'EUR', symbol: '€', rateToINR: 110.80, phoneLen: 10 },
  { code: 'IL', dial: '+972', name: 'Israel', flag: '🇮🇱', currency: 'ILS', symbol: '₪', rateToINR: 31.48, phoneLen: 9 }
];

export const DEFAULT_COUNTRY = COUNTRIES[0]; // India (+91)

export function getCountryByCode(code) {
  if (!code) return DEFAULT_COUNTRY;
  const upper = String(code).toUpperCase().trim();
  return COUNTRIES.find(c => c.code === upper) || DEFAULT_COUNTRY;
}

export function getCountryByDial(dial) {
  if (!dial) return DEFAULT_COUNTRY;
  const cleanDial = dial.startsWith('+') ? dial : `+${dial}`;
  return COUNTRIES.find(c => c.dial === cleanDial) || DEFAULT_COUNTRY;
}

export function inferCountryFromPhone(phone) {
  if (!phone) return DEFAULT_COUNTRY;
  const rawStr = String(phone).trim();
  const digits = rawStr.replace(/[^\d]/g, '');
  const startsWithPlus = rawStr.startsWith('+');

  // Sort countries by dial code length descending so longer codes match first (e.g. +971 before +9)
  const sorted = [...COUNTRIES].sort((a, b) => b.dial.length - a.dial.length);
  for (const c of sorted) {
    const rawDial = c.dial.replace('+', '');
    if (startsWithPlus && digits.startsWith(rawDial)) {
      return c;
    }
    // If no plus, only match if number length exceeds national format
    if (!startsWithPlus && digits.startsWith(rawDial) && digits.length >= rawDial.length + (c.phoneLen || 9)) {
      return c;
    }
  }
  return DEFAULT_COUNTRY;
}

/**
 * Convert an INR amount into the target country's currency with neat rounding
 */
export function convertPlanPrice(inrAmount, targetCurrency = 'INR') {
  const num = Number(inrAmount) || 0;
  if (num === 0) return 0;
  if (!targetCurrency || targetCurrency === 'INR') return num;

  const country = COUNTRIES.find(c => c.currency === targetCurrency);
  const rate = country?.rateToINR || 1;

  const converted = num / rate;

  if (converted < 10) return Math.round(converted * 10) / 10;
  if (converted < 500) return Math.round(converted);
  return Math.round(converted / 5) * 5;
}

/**
 * Format a price with its localized currency symbol
 */
export function formatLocalizedPrice(amount, currency = 'INR', symbol = null) {
  const num = Number(amount) || 0;
  const curr = String(currency || 'INR').toUpperCase();
  const sym = symbol || (COUNTRIES.find(c => c.currency === curr)?.symbol || `${curr} `);

  if (curr === 'INR') {
    return `${sym}${num.toLocaleString('en-IN')}`;
  }
  return `${sym}${num.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}

/**
 * Normalize an international phone number with the country's dial code
 */
export function normalizeInternationalPhone(raw, defaultCountryDial = '+91') {
  if (!raw) return '';
  const rawStr = String(raw).trim();
  let digits = rawStr.replace(/[^\d]/g, '');
  if (!digits) return '';

  const cleanDial = String(defaultCountryDial || '+91').replace('+', '');

  if (digits.startsWith('0')) digits = digits.slice(1);

  // If user explicitly entered +, trust international format
  if (rawStr.startsWith('+')) {
    return digits;
  }

  // If digits already start with cleanDial and have full international length
  if (digits.startsWith(cleanDial) && digits.length >= cleanDial.length + 9) {
    return digits;
  }

  // Check if digits start with another country's dial code with that country's full international length
  const matchedCountry = COUNTRIES.find(c => {
    const d = c.dial.replace('+', '');
    return digits.startsWith(d) && digits.length >= d.length + (c.phoneLen || 9);
  });
  if (matchedCountry) {
    return digits;
  }

  return `${cleanDial}${digits}`;
}

export default COUNTRIES;
